import React from 'react';
import PolButton from "v4/components/ui/PolButton/PolButton";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {useImportTableContext} from "v4/pages/admin/Import/contexts/ImportTableContext";
import ReactTooltip from "react-tooltip";

export default function ValidateImportExportButton() {
    const {t} = usePolTranslation();
    const {onExportDownload} = useImportTableContext();

    return (
        <>
            <ReactTooltip id="validate-import-export-button" effect="solid"/>
            <PolButton
                data-tip={t('export_with_current_filters')}
                data-for="validate-import-export-button"
                onClick={onExportDownload}>
                {t('export')}
            </PolButton>
        </>
    )
}
